// @ts-nocheck
import { Container, Row, Col, Divider } from '@mch-group/uikit-components'
import { FC, useContext } from 'react'
import { LoginContext } from '@providers/Login'
import styled from 'styled-components'
import { connect } from 'react-redux'
import NoSSR from 'react-no-ssr'
import { setSubmitApplication } from '@stores/pressAcc'
import ApplicationAccordion from './ApplicationAccordion'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { getSiteLanguage } from '@utils/storage'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'

const mID = 'press-accreditation-application'

interface IApplication {
  props: any
}

const Application: FC<IApplication> = (props) => {
  const { user } = useContext(LoginContext)
  const { labels: labels } = useLabelsFromAPI(['FieldValidation', 'AltTags'], getSiteLanguage())

  return user?.me ? (
    <StyledContainer className={mID}>
      <Container className={`${mID} px-5 px-md-7 px-lg-8 pb-10 pb-md-10 pb-xl-10`}>
        <Divider color='mch-gray-200' size='m' className='mb-0' />
        <Row>
          <Col xs={12} md={6}>
            <h2 className='my-8 my-md-8 my-xl-9 h3'>{props.mpaa_module_title}</h2>
          </Col>
        </Row>
        <Divider color='mch-gray-200' size='m' className='mb-0' />
        {props?.press?.data?.shows && props?.press?.data?.statuses && props?.press?.data?.profile && (
          <NoSSR>
            <ApplicationAccordion
              shows={props.press.data.shows}
              statuses={props.press.data.statuses}
              props={props}
              profile={props.press.data.profile}
              press={props.press}
              labels={labels}
            />
          </NoSSR>
        )}
      </Container>
    </StyledContainer>
  ) : null
}

const ApplicationConnected = connect(({ press }) => ({ press }), {
  setSubmitApplication
})(Application)

const StyledContainer = styled.div`
  .fileuploader {
    width: 100%;
    min-height: 48px;
    font-size: ${tokens.fontSize[1].value};
    line-height: ${tokensRenamed.lineHeights[1].value};

    input[type='text'] {
      border-radius: 0 !important;
      border: none;
      border-bottom: 1px solid #babfc4 !important;
      padding: 7px 0 0 0;
      text-overflow: ellipsis;
    }

    .btn-primary {
      min-width: 99px !important;
    }
  }

  .ui.action.input > .ui.input {
    width: 100%;

    a {
      position: absolute;
      right: 20px;
      height: 100%;
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;

      svg {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        margin: 0;
        padding: 0;
      }
    }
  }

  .specs {
    font-weight: ${tokens.fontWeights.artBaselText1.value};
  }

  .agree-tc {
    * {
      display: flex;
      align-items: center;
    }

    .form-check.light .form-check-input {
      margin-top: 0;
    }

    p {
      margin-bottom: 0;
    }
  }

  textarea {
    font-size: ${tokens.fontSize[1].value};
    border: 1px solid #babfc4 !important;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: none;
  }

  button[type='submit'] {
    @media (max-width: ${global.uikitVars.breakpointSmMax}) {
      width: 100%;
    }
  }

  .pdf-link {
    @media (max-width: ${global.uikitVars.breakpointSmMax}) {
      display: block;

      button {
        width: 100%;
      }
    }
  }

  .accordion.section-accordion .accordion-body {
    overflow-y: inherit;
  }

  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: inherit;
    flex: 1;
    display: block;
  }

  .website {
    align-self: end;
  }
`

export default ApplicationConnected
